export const Color = {
  black: '#2C3558',
  main: '#9b51e0',
  compulsory: '#E6311A',
  error: '#e6311a',
  input_ButtonOutline: '#D5D3E4'
};
